import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/settings_icon.svg'
import _imports_1 from '@/assets/close_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-72c82430"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "menu"
}
const _hoisted_2 = { class: "settingsHeader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Settings", -1))
const _hoisted_4 = { class: "inputGroup" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Show each character for ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ms ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 500 ")
const _hoisted_9 = { class: "inputGroup" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Pause between characters for ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ms ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 0 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 500 ")
const _hoisted_14 = { class: "inputGroup" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Show a total of ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" characters ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 3 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("50 ")
const _hoisted_19 = { class: "inputGroup" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" The two digits are ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" characters apart ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_23 = ["max"]

import { ref, reactive, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["update"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "update", newSettings: typeof settings): void;
}), expose: any, slots: any, attrs: any }) {

const isOpen = ref(false);
const settings = reactive({
  shownLength: 34,
  emptyLength: 10,
  sequenceLength: 20,
  digitDistance: 4,
});

const storedSettings = localStorage.getItem("settings");
if (storedSettings !== null) {
  try {
    const parsedStoredSettings = JSON.parse(storedSettings);
    settings.shownLength = parsedStoredSettings.shownLength;
    settings.emptyLength = parsedStoredSettings.emptyLength;
    settings.sequenceLength = parsedStoredSettings.sequenceLength;
    settings.digitDistance = parsedStoredSettings.digitDistance;
  } catch {
    localStorage.removeItem("settings");
  }
}



watch(
  settings,
  (v) => {
    const nonReactiveSettings = {
      shownLength: settings.shownLength,
      emptyLength: settings.emptyLength,
      sequenceLength: settings.sequenceLength,
      digitDistance: settings.digitDistance,
    };
    localStorage.setItem("settings", JSON.stringify(nonReactiveSettings));
    emits("update", nonReactiveSettings);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isOpen.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "Settings icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Close icon",
              class: "closeIcon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "preciseInput",
              size: "3",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).shownLength) = $event))
            }, null, 512), [
              [
                _vModelText,
                _unref(settings).shownLength,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_6,
            _createElementVNode("div", null, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "range",
                name: "shownLength",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).shownLength) = $event)),
                min: "1",
                max: "500"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(settings).shownLength,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "preciseInput",
              size: "3",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).emptyLength) = $event))
            }, null, 512), [
              [
                _vModelText,
                _unref(settings).emptyLength,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_11,
            _createElementVNode("div", null, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "range",
                name: "emptyLength",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).emptyLength) = $event)),
                min: "0",
                max: "500"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(settings).emptyLength,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "preciseInput",
              size: "2",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(settings).sequenceLength) = $event))
            }, null, 512), [
              [
                _vModelText,
                _unref(settings).sequenceLength,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_16,
            _createElementVNode("div", null, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "range",
                name: "sequenceLength",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(settings).sequenceLength) = $event)),
                min: "3",
                max: "50"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(settings).sequenceLength,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "preciseInput",
              size: "2",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(settings).digitDistance) = $event))
            }, null, 512), [
              [
                _vModelText,
                _unref(settings).digitDistance,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_21,
            _createElementVNode("div", null, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                type: "range",
                name: "digitDistance",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(settings).digitDistance) = $event)),
                min: "1",
                max: _unref(settings).sequenceLength
              }, null, 8, _hoisted_23), [
                [
                  _vModelText,
                  _unref(settings).digitDistance,
                  void 0,
                  { number: true }
                ]
              ]),
              _createTextVNode(_toDisplayString(_unref(settings).sequenceLength), 1)
            ])
          ])
        ]))
  ]))
}
}

})